import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConsultaPublicaColeModel } from './../../models/consultaPublicaCole.Model';
import { ServicioEnviarMailModel } from './../../models/servicioEnviarMail.Model';
import Swal from 'sweetalert2';
import ConfiguracionesServicios from './../configuracionServicios';


@Injectable({
  providedIn: 'root'
})
export class ContactoViaMailService {

  private enviarMail: ServicioEnviarMailModel;

  constructor(private http: HttpClient) { 
    this.enviarMail = new ServicioEnviarMailModel();
  }

  enviarMailContactoPublico(consulta: ConsultaPublicaColeModel){

    console.log('entro al sevicio nuevoUsuario Service');    
    Swal.fire({
      text: 'Recompilando informacion, Espere por favor...'
    });
    Swal.showLoading();

    // Aqui armo el formato del mail que vamos a enviar
    let mensaje: string = '';

    mensaje = '<strong>Apellido: </strong>' + consulta.apellido +
              '<br><strong>Nombre: </strong>' + consulta.nombre +
              '<br><strong>Telefono: </strong>' + consulta.telefono +
              '<br><strong>Correo Electronico: </strong>' + consulta.mail +
              '<br><br>' + consulta.mensaje;

    // setiamos el this.enviarMail para enviarlo al servicio
    // this.enviarMail = consulta;    
    this.enviarMail.destinatario = 'sanjeronimoadultos@gmail.com';
    this.enviarMail.remitente = consulta.mail;
    this.enviarMail.asunto = 'Consulta de ' + consulta.nombre + ' ' + consulta.apellido;
    this.enviarMail.cuerpoMail = mensaje;

    return this.http.post<ServicioEnviarMailModel>(
      ConfiguracionesServicios.servicoContactoEnviarMail, this.enviarMail);
  }


}
